import { 
  ADD_BRANCH,
  ADD_BRANCH_ERROR,
  ADD_BRANCH_SUCCESS,
  ADD_COMPLETION_TIME,
  ADD_COMPLETION_TIME_ERROR,
  ADD_COMPLETION_TIME_SUCCESS,
  ADD_LANGUAGE,
  ADD_LANGUAGE_ERROR,
  ADD_LANGUAGE_SUCCESS,
  ADD_SERVICE, 
  ADD_SERVICE_ERROR, 
  ADD_SERVICE_SUCCESS, 
  ADD_WORD, 
  ADD_WORD_ERROR, 
  ADD_WORD_SUCCESS, 
  DELETE_SERVICE, 
  DELETE_SERVICE_ERROR, 
  DELETE_SERVICE_SUCCESS, 
  EDIT_BRANCH, 
  EDIT_BRANCH_ERROR, 
  EDIT_BRANCH_SUCCESS, 
  EDIT_COMPLETION_TIME, 
  EDIT_COMPLETION_TIME_ERROR, 
  EDIT_COMPLETION_TIME_SUCCESS, 
  EDIT_LANGUAGE, 
  EDIT_LANGUAGE_ERROR, 
  EDIT_LANGUAGE_SUCCESS, 
  EDIT_SERVICE, 
  EDIT_SERVICE_ERROR, 
  EDIT_SERVICE_SUCCESS, 
  EDIT_WORD, 
  EDIT_WORD_ERROR, 
  EDIT_WORD_SUCCESS, 
  GET_BRANCHS, 
  GET_BRANCHS_ERROR, 
  GET_BRANCHS_SUCCESS, 
  GET_COMPLETION_TIMES, 
  GET_COMPLETION_TIMES_ERROR, 
  GET_COMPLETION_TIMES_SUCCESS, 
  GET_LANGUAGES, 
  GET_LANGUAGES_ERROR, 
  GET_LANGUAGES_SUCCESS,
  GET_SERVICES, 
  GET_SERVICES_ERROR, 
  GET_SERVICES_SUCCESS, 
  GET_WORDS,
  GET_WORDS_ERROR,
  GET_WORDS_SUCCESS,
  GET_VIEWS,
  GET_VIEWS_SUCCESS,
  GET_VIEWS_ERROR,
  GET_ANNUAL_STATISTICS,
  GET_ANNUAL_STATISTICS_SUCCESS,
  GET_ANNUAL_STATISTICS_ERROR
} from "redux/constants/Settings";

/**
 * GET SERVICES
 * @returns 
 */
export const getServices = () => {
  return {
    type: GET_SERVICES,
  }
};

/**
 * GET SERVICES SUCCESS
 * @param {*} universities 
 * @returns 
 */
export const getServicesSuccess = (services) => {
  return {
    type: GET_SERVICES_SUCCESS,
    services
  }
};

/**
 * GET SERVICES ERROR
 * @param {*} message 
 * @returns 
 */
export const getServicesError = (message) => {
  return {
    type: GET_SERVICES_ERROR,
    message
  }
};

/**
 * DELETE SERVICE
 * @returns 
 */
export const deleteService = (id, cb = () => {}) => {
  return {
    type: DELETE_SERVICE,
    payload: {
      id,
      cb
    }
  }
};

/**
 * DELETE SERVICE SUCCESS
 * @returns 
 */
export const deleteServiceSuccess = (data, cb = () => {}) => {
  return {
    type: DELETE_SERVICE_SUCCESS,
  }
};

/**
 * DELETE SERVICE ERROR
 * @returns 
 */
export const deleteServiceError = (data, cb = () => {}) => {
  return {
    type: DELETE_SERVICE_ERROR,
  }
};

/**
 * ADD SERVICE
 * @returns 
 */
export const addService = (data, cb = () => {}) => {
  return {
    type: ADD_SERVICE,
    payload: {
      data,
      cb
    }
  }
};

/**
 * ADD SERVICE SUCCESS
 * @returns 
 */
export const addServiceSuccess = (data, cb = () => {}) => {
  return {
    type: ADD_SERVICE_SUCCESS,
  }
};

/**
 * ADD SERVICE ERROR
 * @returns 
 */
export const addServiceError = (data, cb = () => {}) => {
  return {
    type: ADD_SERVICE_ERROR,
  }
};

/**
 * EDIT SERVICE
 * @returns 
 */
export const editService = (data, cb = () => {}) => {
  return {
    type: EDIT_SERVICE,
    payload: {
      data,
      cb
    }
  }
};

/**
 * EDIT SERVICE SUCCESS
 * @returns 
 */
export const editServiceSuccess = (data, cb = () => {}) => {
  return {
    type: EDIT_SERVICE_SUCCESS,
  }
};

/**
 * EDIT SERVICE ERROR
 * @returns 
 */
export const editServiceError = (data, cb = () => {}) => {
  return {
    type: EDIT_SERVICE_ERROR,
  }
};

/**
 * GET BRANCHS
 * @returns 
 */
 export const getBranchs = () => {
  return {
    type: GET_BRANCHS,
  }
};

/**
 * GET BRANCHS SUCCESS
 * @param {*} branchs 
 * @returns 
 */
export const getBranchsSuccess = (branchs) => {
  return {
    type: GET_BRANCHS_SUCCESS,
    branchs
  }
};

/**
 * GET BRANCHS ERROR
 * @param {*} message 
 * @returns 
 */
export const getBranchsError = (message) => {
  return {
    type: GET_BRANCHS_ERROR,
    message
  }
};


/**
 * ADD BRANCH
 * @returns 
 */
 export const addBranch = (data, cb = () => {}) => {
  return {
    type: ADD_BRANCH,
    payload: {
      data,
      cb
    }
  }
};

/**
 * ADD BRANCH SUCCESS
 * @returns 
 */
export const addBranchSuccess = (data, cb = () => {}) => {
  return {
    type: ADD_BRANCH_SUCCESS,
  }
};

/**
 * ADD BRANCH ERROR
 * @returns 
 */
export const addBranchError = (data, cb = () => {}) => {
  return {
    type: ADD_BRANCH_ERROR,
  }
};

/**
 * EDIT BRANCH
 * @returns 
 */
 export const editBranch = (data, cb = () => {}) => {
  return {
    type: EDIT_BRANCH,
    payload: {
      data,
      cb
    }
  }
};

/**
 * EDIT BRANCH SUCCESS
 * @returns 
 */
export const editBranchSuccess = (data, cb = () => {}) => {
  return {
    type: EDIT_BRANCH_SUCCESS,
  }
};

/**
 * EDIT BRANCH ERROR
 * @returns 
 */
export const editBranchError = (data, cb = () => {}) => {
  return {
    type: EDIT_BRANCH_ERROR,
  }
};

/**
 * GET LANGUAGES
 * @returns 
 */
 export const getLanguages = () => {
  return {
    type: GET_LANGUAGES,
  }
};

/**
 * GET LANGUAGES SUCCESS
 * @param {*} languages 
 * @returns 
 */
export const getLanguagesSuccess = (languages) => {
  return {
    type: GET_LANGUAGES_SUCCESS,
    languages
  }
};

/**
 * GET LANGUAGES ERROR
 * @param {*} message 
 * @returns 
 */
export const getLanguagesError = (message) => {
  return {
    type: GET_LANGUAGES_ERROR,
    message
  }
};

/**
 * ADD LANGUAGE
 * @returns 
 */
export const addLanguage = (data, cb = () => {}) => {
  return {
    type: ADD_LANGUAGE,
    payload: {
      data,
      cb
    }
  }
};

/**
 * ADD LANGUAGE SUCCESS
 * @returns 
 */
export const addLanguageSuccess = (data, cb = () => {}) => {
  return {
    type: ADD_LANGUAGE_SUCCESS,
  }
};

/**
 * ADD LANGUAGE ERROR
 * @returns 
 */
export const addLanguageError = (data, cb = () => {}) => {
  return {
    type: ADD_LANGUAGE_ERROR,
  }
};

/**
 * EDIT LANGUAGE
 * @returns 
 */
 export const editLanguage = (data, cb = () => {}) => {
  return {
    type: EDIT_LANGUAGE,
    payload: {
      data,
      cb
    }
  }
};

/**
 * EDIT LANGUAGE SUCCESS
 * @returns 
 */
export const editLanguageSuccess = (data, cb = () => {}) => {
  return {
    type: EDIT_LANGUAGE_SUCCESS,
  }
};

/**
 * EDIT LANGUAGE ERROR
 * @returns 
 */
export const editLanguageError = (data, cb = () => {}) => {
  return {
    type: EDIT_LANGUAGE_ERROR,
  }
};

/**
 * GET COMPLETION TIMES
 * @returns 
 */
export const getCompletionTimes = () => {
  return {
    type: GET_COMPLETION_TIMES,
  }
};

/**
 * GET COMPLETION TIMES SUCCESS
 * @param {*} completionTimes 
 * @returns 
 */
export const getCompletionTimesSuccess = (completionTimes) => {
  return {
    type: GET_COMPLETION_TIMES_SUCCESS,
    completionTimes
  }
};

/**
 * GET COMPLETION TIMES ERROR
 * @param {*} message 
 * @returns 
 */
export const getCompletionTimesError = (message) => {
  return {
    type: GET_COMPLETION_TIMES_ERROR,
    message
  }
};

/**
 * ADD COMPLETION TIME
 * @returns 
 */
 export const addCompletionTime = (data, cb = () => {}) => {
  return {
    type: ADD_COMPLETION_TIME,
    payload: {
      data,
      cb
    }
  }
};

/**
 * ADD COMPLETION TIME SUCCESS
 * @returns 
 */
export const addCompletionTimeSuccess = (data, cb = () => {}) => {
  return {
    type: ADD_COMPLETION_TIME_SUCCESS,
  }
};

/**
 * ADD COMPLETION TIME ERROR
 * @returns 
 */
export const addCompletionTimeError = (data, cb = () => {}) => {
  return {
    type: ADD_COMPLETION_TIME_ERROR,
  }
};

/**
 * EDIT COMPLETION TIME
 * @returns 
 */
 export const editCompletionTime = (data, cb = () => {}) => {
  return {
    type: EDIT_COMPLETION_TIME,
    payload: {
      data,
      cb
    }
  }
};

/**
 * EDIT COMPLETION TIME SUCCESS
 * @returns 
 */
export const editCompletionTimeSuccess = (data, cb = () => {}) => {
  return {
    type: EDIT_COMPLETION_TIME_SUCCESS,
  }
};

/**
 * EDIT COMPLETION TIME ERROR
 * @returns 
 */
export const editCompletionTimeError = (data, cb = () => {}) => {
  return {
    type: EDIT_COMPLETION_TIME_ERROR,
  }
};

/**
 * GET WORDS
 * @returns 
 */
export const getWords = () => {
  return {
    type: GET_WORDS,
  }
};

/**
 * GET WORDS SUCCESS
 * @param {*} words 
 * @returns 
 */
export const getWordsSuccess = (words) => {
  return {
    type: GET_WORDS_SUCCESS,
    words
  }
};

/**
 * GET WORDS ERROR
 * @param {*} message 
 * @returns 
 */
export const getWordsError = (message) => {
  return {
    type: GET_WORDS_ERROR,
    message
  }
};

/**
 * ADD WORD
 * @returns 
 */
 export const addWord = (data, cb = () => {}) => {
  return {
    type: ADD_WORD,
    payload: {
      data,
      cb
    }
  }
};

/**
 * ADD WORD SUCCESS
 * @returns 
 */
export const addWordSuccess = (data, cb = () => {}) => {
  return {
    type: ADD_WORD_SUCCESS,
  }
};

/**
 * ADD WORD ERROR
 * @returns 
 */
export const addWordError = (data, cb = () => {}) => {
  return {
    type: ADD_WORD_ERROR,
  }
};

/**
 * EDIT WORD
 * @returns 
 */
 export const editWord = (data, cb = () => {}) => {
  return {
    type: EDIT_WORD,
    payload: {
      data,
      cb
    }
  }
};

/**
 * EDIT WORD SUCCESS
 * @returns 
 */
export const editWordSuccess = (data, cb = () => {}) => {
  return {
    type: EDIT_WORD_SUCCESS,
  }
};

/**
 * EDIT WORD ERROR
 * @returns 
 */
export const editWordError = (data, cb = () => {}) => {
  return {
    type: EDIT_WORD_ERROR,
  }
};

/**
 * GET VIEWS
 * @returns 
 */
 export const getViews = (country) => {
  return {
    type: GET_VIEWS,
    payload: {
      country
    }
  }
};

/**
 * GET VIEWS SUCCESS
 * @param {*} views 
 * @returns 
 */
export const getViewsSuccess = (views) => {
  return {
    type: GET_VIEWS_SUCCESS,
    views
  }
};

/**
 * GET VIEWS ERROR
 * @param {*} message 
 * @returns 
 */
export const getViewsError = (message) => {
  return {
    type: GET_VIEWS_ERROR,
    message
  }
};

/**
 * GET ANNUAL STATISTICS
 * @returns 
 */
 export const getAnnualStatistics = () => {
  return {
    type: GET_ANNUAL_STATISTICS,
  }
};

/**
 * GET ANNUAL STATISTICS SUCCESS
 * @param {*} views 
 * @returns 
 */
export const getAnnualStatisticsSuccess = (annualStatistics) => {
  return {
    type: GET_ANNUAL_STATISTICS_SUCCESS,
    annualStatistics
  }
};

/**
 * GET ANNUAL STATISTICS ERROR
 * @param {*} message 
 * @returns 
 */
export const getAnnualStatisticsError = (message) => {
  return {
    type: GET_ANNUAL_STATISTICS_ERROR,
    message
  }
};
